// extracted by mini-css-extract-plugin
module.exports = {"doughnutInformation":"DoughnutInformation_doughnutInformation__2N_OT","content":"DoughnutInformation_content__2IjeW","title":"DoughnutInformation_title__yfXcI"};